module.exports = "<div class=\"form-group\">\r\n\t<label *ngIf=\"label\" class=\"form-control-label\">{{label}}</label>\r\n\t<div class=\"input-group\">\r\n\t\t<input class=\"form-control\" i18n-placeholder placeholder=\"Od\" [ngModel]=\"start\" (ngModelChange)=\"startChanged($event)\" sm-only-numbers type=\"number\" min=\"1\" />\r\n\t<label class=\"hyphen mt-1\">-</label>\r\n\t\t<input class=\"form-control\" i18n-placeholder placeholder=\"Do\" [ngModel]=\"end\" (ngModelChange)=\"endChanged($event)\" sm-only-numbers type=\"number\" min=\"1\" />\r\n\t</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-number-range.component.html
// module id = 432
// module chunks = 11